import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import { setActiveOrder } from "../../store/features/orderSlice";

const STATUSES = [
  { id: "all", title: "Все", color: "#008bd9" },
  { id: "new", title: "Новый", color: "#008bd9" },
  { id: "processing", title: "В обработке", color: "#008bd9" },
  { id: "shipped", title: "Отправлен", color: "#008bd9" },
  { id: "closed", title: "Завершен", color: "#008bd9" },
  { id: "canceled", title: "Отменен", color: "#008bd9" },
];

const ITEMS_PER_PAGE = 25;

const OrderList = () => {
  const { orders } = useSelector((state) => state.order);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();

  const setOrder = (activeOrder) => {
    dispatch(setActiveOrder(activeOrder));
  };

  if (!orders) return null;

  const filteredOrders =
    selectedStatus === "all"
      ? orders
      : orders.filter((order) => order.status === selectedStatus);

  const searchedOrders = filteredOrders.filter((order) => {
    const lowerSearch = searchTerm.toLowerCase();
    return (
      order.key.toLowerCase().includes(lowerSearch) ||
      order.shop?.name?.toLowerCase().includes(lowerSearch) ||
      order.amount.toString().includes(lowerSearch)
    );
  });

  const totalPages = Math.ceil(searchedOrders.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentOrders = searchedOrders.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const getStatusTitle = (statusId) =>
    STATUSES.find((s) => s.id === statusId)?.title || statusId;

  const formatDate = (date) => {
    const parsedDate = new Date(date);
    return isNaN(parsedDate)
      ? "Неизвестная дата"
      : parsedDate.toLocaleString("ru-RU", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
  };

  return (
    <div className="orderList">
      <div className="orderList__top">
        <div className="orderList__filter">
          {STATUSES.map((status) => (
            <button
              key={status.id}
              style={{
                backgroundColor:
                  selectedStatus === status.id ? status.color : "#9f9f9f",
              }}
              onClick={() => {
                setSelectedStatus(status.id);
                setCurrentPage(1);
              }}
            >
              {status.title}
            </button>
          ))}
        </div>

        <input
          className="orderList__search"
          type="text"
          placeholder="Поиск по заказу, магазину или сумме"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      <table className="orderList__table">
        <thead>
          <tr>
            <th>№ заказа</th>
            <th>Статус</th>
            <th>Сумма</th>
            <th>Магазин</th>
            <th>Кол-во товаров</th>
            <th>Дата</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {currentOrders.map((order) => (
            <tr key={order.id}>
              <td>{order.key}</td>
              <td className="orderList__status">
                {getStatusTitle(order.status)}
                <span
                  style={{
                    backgroundColor:
                      STATUSES.find((s) => s.id === order.status)?.color ||
                      "#ccc",
                  }}
                ></span>
              </td>
              <td>{order.amount} сом</td>
              <td>{order.shop?.name || "-"}</td>
              <td>{order.products?.length || 0}</td>
              <td>{formatDate(order.createdAt)}</td>
              <td>
                <button
                  className="orderList__more"
                  onClick={() => setOrder(order)}
                >
                  Подробнее
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="orderList__pagination">
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            className={currentPage === index + 1 ? "active" : ""}
            onClick={() => {
              setCurrentPage(index + 1);
            }}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default OrderList;
